import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save, Plus, X } from "lucide-react";
import { Header, Section, Field, TextArea } from "./TextsTab";

export default function ServicesTab() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState(null);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/services"); setServices(data); }
    catch (e) { toast.error("No se pudieron cargar los servicios"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const update = (id, patch) => setServices((arr) => arr.map((s) => s.id === id ? { ...s, ...patch } : s));
  const updateBullet = (id, i, v) => update(id, { bullets: services.find((s) => s.id === id).bullets.map((b, idx) => idx === i ? v : b) });
  const addBullet = (id) => update(id, { bullets: [...services.find((s) => s.id === id).bullets, ""] });
  const removeBullet = (id, i) => update(id, { bullets: services.find((s) => s.id === id).bullets.filter((_, idx) => idx !== i) });

  const save = async (svc) => {
    setSavingId(svc.id);
    try {
      await api.put(`/admin/services/${svc.id}`, svc);
      toast.success(`Guardado: ${svc.title}`);
    } catch (e) { toast.error("Error al guardar"); }
    finally { setSavingId(null); }
  };

  if (loading) return <div className="text-[#7da3ff] mono">Cargando servicios…</div>;

  return (
    <div className="space-y-6 max-w-5xl">
      <Header title="Servicios" subtitle="Editá títulos, descripciones y viñetas de los servicios." />
      {services.map((svc, idx) => (
        <div key={svc.id} className="glass rounded-2xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#7da3ff]">{String(idx+1).padStart(2,"0")} · {svc.code}</div>
            <button onClick={() => save(svc)} disabled={savingId === svc.id} className="btn-primary text-xs px-4 py-2 rounded-lg inline-flex items-center gap-2"><Save className="w-3 h-3" /> {savingId === svc.id ? "…" : "Guardar"}</button>
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            <Field label="Título" value={svc.title} onChange={(v) => update(svc.id, { title: v })} />
            <Field label="Tag (subtítulo)" value={svc.tag} onChange={(v) => update(svc.id, { tag: v })} />
            <Field label="Código (chip)" value={svc.code} onChange={(v) => update(svc.id, { code: v })} />
            <Field label="Orden" type="number" value={svc.order} onChange={(v) => update(svc.id, { order: parseInt(v) || 0 })} />
          </div>
          <div className="mt-3">
            <TextArea label="Descripción corta" value={svc.short} onChange={(v) => update(svc.id, { short: v })} />
          </div>
          <div className="mt-4">
            <div className="flex items-center justify-between mb-2">
              <label className="text-xs text-[#9bb0e0]">Viñetas (mostradas al voltear la card)</label>
              <button onClick={() => addBullet(svc.id)} className="btn-ghost text-xs px-3 py-1.5 rounded-lg inline-flex items-center gap-1"><Plus className="w-3 h-3" /> agregar</button>
            </div>
            <div className="space-y-2">
              {svc.bullets.map((b, i) => (
                <div key={i} className="flex gap-2">
                  <input value={b} onChange={(e) => updateBullet(svc.id, i, e.target.value)} className="flex-1 bg-[rgba(10,20,55,0.5)] border border-[rgba(120,160,255,0.18)] rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-[#5fa0ff]" />
                  <button onClick={() => removeBullet(svc.id, i)} className="w-9 h-9 rounded-lg glass flex items-center justify-center text-[#ff8a8a]"><X className="w-4 h-4" /></button>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
